export var VELT_SDK_VERSION = '4.5.0-beta.65';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.0-beta.65': 'sha384-EFT92ZqugJYFxfpfwqWrKesBT9aGGJ9f7wqrBhXBQEG12vQYRLqzw6EQwWve4m96',
};
